export default {
  "b2b.provozni-informace.page-heading": "Operational information management",
  "b2b.provozni-informace.page-heading.action-filter": "Filter",
  "b2b.provozni-informace.page-heading.action-add": "New information"
};
